import { createSelector } from "reselect";
const getMessagesVisibility = state => state.messages.messagesVisibility;

export const getMessageVisibility = key =>
  createSelector(
    [getMessagesVisibility],
    messagesVisibility =>
      messagesVisibility[key] == undefined ? true : messagesVisibility[key]
  );



// WEBPACK FOOTER //
// ./src/messages/selectors.js